import React, { Component } from 'react';
import { Table, message, Popconfirm, Button } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import './style.less';
import send from '../../util/request';
import CpProductChoose from './CpProductChoose';
import cpSelected from '../../assets/cp-selected.png';
import { getAddressList } from '../apis/address';
import CpEmpty from '../../components/CpEmpty';

const { localStorage, location } = window;

const addressItem = item => {
  return (
    (!item || !item.id) ? null : (
      <div>
        <span>{item.username}</span>
        <span style={{ marginLeft: '20px' }}>{item.province_name + item.city_name + item.area_name + item.address}</span>
        <span style={{ marginLeft: '20px' }}>{item.phone}</span>
        <span style={{ marginLeft: '20px' }}>{item?.warehouse?.warehouse_name}</span>
      </div>
    )
  );
};

class selectProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [],
      productObj: {},
      visible: false,
      currentProductList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      provinceList: [],
      cityList: [],
      provinceId: '',
      cityId: null,
      svcData: [],//svc区域
      svcId: '',
      svcName: '',
      addressList: [],
      addressIsFold: true,
      currentAddress: {},
      otherAddressList: [],
    };

    const { taskNo, supplierName, supplierCode } = this.props.match.params;
    this.taskNo = taskNo;
    this.supplierName = supplierName;
    this.supplierCode = supplierCode;
  }
  columns = [
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
      width: 180
    },
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      align: 'center',
      width: 120
    },
    {
      title: '等级',
      dataIndex: 'level',
      key: 'level',
      align: 'center',
    },
    {
      title: '产地',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: '单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      width: 120
    },
    {
      title: '单位重量(KG)',
      dataIndex: 'weight',
      key: 'weight',
      align: 'center',
      width: 120
    },
    {
      title: '商品报价',
      dataIndex: 'sale_price',
      key: 'sale_price',
      align: 'center',
      width: 120,
      render: (text, record) => {
        const { is_qoute = false } = record;
        return is_qoute ? `¥${text}` : '未报价';
      }
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      render: (text, record) => (
        <Popconfirm
          title="是否要移除?"
          onConfirm={() => this.handleDelete(record, 1)}
          okText="确定"
          cancelText="取消">
          <a style={{ color: '#D60505' }}>移除</a>
        </Popconfirm>
      ),
    },
  ]

  componentDidMount() {
    const info = location.href.split('/');
    const taskNo = info[info.length - 3], supplierName = decodeURI(info[info.length - 2]), supplierCode = info[info.length - 1];
    localStorage.setItem('taskData', JSON.stringify({ taskNo, supplierName, supplierCode }));
    const account = localStorage.getItem('account');
    const companyId = localStorage.getItem('companyId');
    const companyName = localStorage.getItem('companyName');
    this.setState({
      account,
      companyId,
      companyName,
      supplierName
    });
    this.requestAddressList({ plan_order_no: taskNo });
  }

  requestAddressList = async params => {
    let { data: { data: { list = [] } } } = await getAddressList(params);
    list.sort((a, b) => b.is_default - a.is_default);
    this.setState({ addressList: list, currentAddress: list[0], otherAddressList: list.slice(1) });
  }

  componentWillUnmount() {
    this.setState = () => false;
  }
  requestSvcName = () => {
    send({
      url: '/ipp/common/svc',
      method: 'POST',
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { data = [] } = res.data;
        this.setState({
          svcData: data
        });
      }
    });
  }
  requestAreaData(pid = 0) {
    send({
      url: '/ipp/order-plan-task/area',
      method: 'GET',
      params: {
        pid
      }
    }).then((res) => {
      if (res.data && res.data.code === 0) {
        const { data = [] } = res.data;
        if (pid === 0) {
          this.setState({
            provinceList: data
          });
        } else {
          this.setState({
            cityList: data
          });
        }
      }
    });
  }
  handleDelete = (record, type) => {
    let { selectedRowKeys, productObj, productList } = this.state;
    let array = [];
    if (type === 1) {
      array = [record.good_id];
    } else {
      array = selectedRowKeys;
    }

    array.forEach(item => {
      delete productObj[item];
    });
    productList = Object.values(productObj);
    this.setState({
      productObj,
      productList,
      total: productList.length,
      selectedRowKeys: []
    }, () => {
      this.handleProductList();
    });
  }
  selectProduct = () => {
    this.setState({
      visible: true
    });
  }
  hideModal = () => {
    this.setState({ visible: false });
  }
  submitModal = (submitObj) => {
    let { productObj, productList } = this.state;
    productObj = Object.assign({}, productObj, submitObj);
    productList = Object.values(productObj);
    this.setState({
      productObj,
      productList,
      total: productList.length
    }, () => {
      this.handleProductList();
    });
    this.setState({ visible: false });
  }
  handleProductList = () => {
    const { currentPage, pageSize, productList } = this.state;
    let start = (currentPage - 1) * pageSize;
    let end = start + pageSize;
    let currentProductList = productList.slice(start, end);
    this.setState({
      currentProductList
    });
  }
  submit = () => {
    const { productList, currentAddress } = this.state;

    if (!productList.length) {
      message.info('请先选择商品');
      return;
    }
    const { companyId } = this.state;
    const productIds = productList.map(obj => obj.good_id);
    let data = {
      order_no: this.taskNo,
      order_goods_id: productIds.join(','),
      purchase_id: companyId,
      address_id: currentAddress?.id
    };
    send({
      url: '/ipp/order-plan-task/submit-create',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        this.props.history.push('/basic/user/planReport');
      } else {
        message.error(res.data.msg);
      }
    });
  }
  cancelAction = () => {
    this.props.history.go(-1);
  }
  moreBtnClicked = () => {
    this.setState({
      addressIsFold: !this.state.addressIsFold
    });
  }
  selectAddress = (addressId) => {
    let currentAddress = {};
    let otherAddressList = [];
    this.state.addressList.forEach(obj => {
      if (Number(obj.id) === Number(addressId)) {
        currentAddress = obj;
      } else {
        otherAddressList.push(obj);
      }
    });
    this.setState({
      addressIsFold: true,
      currentAddress,
      otherAddressList,
      currentProductList: []
    });
  }
  render() {
    const { visible, currentProductList, currentPage, pageSize, total, selectedRowKeys, addressList = [], addressIsFold, currentAddress = {}, otherAddressList = [], supplierName } = this.state;
    const chooseCheck = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          isBatchAdd: selectedRowKeys.length > 0 ? true : false,
          addList: selectedRows,
          selectedRowKeys,
        });
      },
    };
    const empty = (
      <div className="address-empty">
        <CpEmpty status='planOrderAddress' history={this.props.history} onClicked={this.handleAreaModalAdd} />
      </div>
    );
    return (
      <div className="select-products">
        {
          !(addressList?.length) ? <div className='select-products-no-address'>
            {empty}
            {/* <span>您还没有收货地址，请先添加收货地址再进行提报</span>
            <Button type='link'><Link to={'/basic/user/address'}>去添加收货地址</Link></Button> */}
          </div> : <>
            <div className="title">计划提报商品清单</div>
            <div className="address-info">
              <div className="address-title">收货信息</div>
              <div className="address-list">
                <div className="left">
                  {
                    addressList?.length && (
                      <>
                        <div className="default-address">
                          <div className="address-item">
                            {addressItem(currentAddress)}
                            {/* <span className='pointer' onClick={this.editAddress}>编辑</span> */}
                            <img className="cp-selected-icon" src={cpSelected} alt=""></img>
                          </div>
                        </div>
                        {
                          !addressIsFold && (
                            <div className="other-address">
                              {
                                otherAddressList.map((item, index) => {
                                  return (
                                    <div key={index} className="address-item other" onClick={() => { this.selectAddress(item.id); }}>
                                      {addressItem(item)}
                                    </div>
                                  );
                                })
                              }
                            </div>
                          )
                        }
                        {
                          addressList.length > 1 && (
                            <Button className="address-more" onClick={this.moreBtnClicked}>
                              {
                                addressIsFold ? '更多地址' : '收起更多地址'
                              }
                              {
                                addressIsFold ? <DownOutlined style={{ marginLeft: '10px' }} /> : <UpOutlined style={{ marginLeft: '10px' }} />
                              }
                            </Button>
                          )
                        }
                      </>
                    )
                  }
                </div>
                {/* <span className='pointer' onClick={this.addNewAddress}>新增收货地址</span> */}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
              <div>
                <Button type="primary" style={{ marginTop: '10px' }} onClick={this.selectProduct} disabled={!currentAddress?.is_commit}>选择商品</Button>
                {!currentAddress?.is_commit ? <Button type='link'>当前收货地址无报价，请联系{supplierName}</Button> : null}
              </div>
              {/* <Button disabled={!isBatchAdd} type="primary" style={{ marginTop: '10px' }} onClick={this.handleDelete}>批量移除</Button> */}
              <Button disabled={!(selectedRowKeys || []).length} type="primary" style={{ marginTop: '10px' }} onClick={this.handleDelete}>批量移除</Button>
            </div>
            <div>
              <Table
                rowKey={record => record.good_id}
                columns={this.columns}
                dataSource={currentProductList}
                rowSelection={chooseCheck}
                scroll={{ x: 1000 }}
                pagination={{
                  pageSize: pageSize,
                  total: total,
                  current: currentPage,
                  onChange: (currentPage, pageSize) => {
                    this.setState(
                      {
                        currentPage,
                        pageSize,
                      },
                      () => {
                        this.handleProductList();
                      }
                    );
                  },
                }}
              />
            </div>
            <div style={{ margin: '40px 0px', textAlign: 'center' }}>
              <Button type="primary" onClick={this.submit}>提交</Button>
              <Button style={{ marginLeft: '20px' }} onClick={this.cancelAction}>取消</Button>
            </div>
            {
              visible ? <CpProductChoose
                taskNo={this.taskNo}
                addressId={currentAddress?.id}
                hideModal={this.hideModal}
                submitModal={this.submitModal}>
              </CpProductChoose> : null
            }</>
        }
      </div>
    );
  }
}
export default selectProducts;